/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_S62_Item_1Inputs */

const es_tyc_liability_s62_item_1 = /** @type {(inputs: Tyc_Liability_S62_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muerte o dano personal causado por negligencia grave.`)
};

const en_tyc_liability_s62_item_1 = /** @type {(inputs: Tyc_Liability_S62_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Death or personal injury caused by gross negligence.`)
};

/**
* | output |
* | --- |
* | "Death or personal injury caused by gross negligence." |
*
* @param {Tyc_Liability_S62_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_s62_item_1 = /** @type {((inputs?: Tyc_Liability_S62_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_S62_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_s62_item_1(inputs)
	return en_tyc_liability_s62_item_1(inputs)
});
export { tyc_liability_s62_item_1 as "tyc.liability.s62_item_1" }